import axios from "axios";
import { getActivity } from "../redux/reducer/activity/activityReducer";
import { getUserManagement } from "../redux/reducer/userManagement/userManagementReducer";
import { getRole } from "../redux/reducer/role/roleReducer";
import { getBank } from "../redux/reducer/bank/bankReducer";
import { getJobPosition } from "../redux/reducer/jobPosition/jobPositionReducer";
import { getPriceType } from "../redux/reducer/priceType/priceTypeReducer";
import { getWorkingArea } from "../redux/reducer/workingArea/workingAreaReducer";
import { getWorkingStatus } from "../redux/reducer/workingStatus/workingStatusReducer";
import { getEmployee } from "../redux/reducer/employee/employeeReducer";
import { getUnitWeight } from "../redux/reducer/unitWeight/unitWeightReducer";
import { getVegetableType } from "../redux/reducer/vegetableType/vegetableTypeReducer";
import { getVegetable } from "../redux/reducer/vegetable/vegetableReducer";
import { getVegetablePrice } from "../redux/reducer/vegetablePrice/vegetablePriceReducer";
import { getFarmer } from "../redux/reducer/farmer/farmerReducer";
import { getCustomerGroup } from "../redux/reducer/customerGroup/customerGroupReducer";
import { getCustomerRegion } from "../redux/reducer/customerRegion/customerRegionReducer";
import { getGoodsCategory } from "../redux/reducer/goodsCategory/goodsCategoryReducer";
import { getGoodsOperational } from "../redux/reducer/goodsOperational/goodsOperationalReducer";
import { getDeliveryVehicle } from "../redux/reducer/deliveryVehicle/deliveryVehicleReducer";
import { getCustomer } from "../redux/reducer/customer/customerReducer";
import { getDailyActivity } from "../redux/reducer/dailyActivity/dailyActivityReducer";
import {
  getReportActivity,
  getReportNoActivity,
} from "../redux/reducer/dailyActivity/reportDailyActivityReducer";
import moment from "moment";
import {
  getHarvestEstimate,
  getHarvestEstimateDashboard,
} from "../redux/reducer/harvest-estimate/harvestEstimateReducer";
import { getHarvest } from "../redux/reducer/harvest/harvestReducer";
import { getPurchaseOrder } from "../redux/reducer/purchaseOrder/purchaseOrderReducer";
import { getPurchaseOrderCust } from "../redux/reducer/purchaseOrderCust/purchaseOrderCustReducer";
import { getStockVegetables } from "../redux/reducer/stock-vegetables/stockVegetablesReducer";
import { getDeliveryOrder } from "../redux/reducer/deliveryOrder/deliveryOrderReducer";
import { getStockOperationalGoods } from "../redux/reducer/stock-operational-goods/stockOperationalGoodsReducer";
import { getInvoice } from "../redux/reducer/invoice/invoiceReducer";
import { getDebtPlastic } from "../redux/reducer/debtPlastic/debtPlasticReducer";
import { getOperationalSubmission } from "../redux/reducer/operationalSubmission/operationalSubmissionReducer";
import { getDebtMoney } from "../redux/reducer/debtMoney/debtMoneyReducer";
import { getPurchaseOrderFarmer } from "../redux/reducer/purchaseOrderFarmer/purchaseOrderFarmerReducer";

const API_URL = "http://localhost:3008/api/v1";

export async function getData(target, token, param) {
  let head = {};
  if (param) {
    head = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
      params: param,
    };
  } else {
    head = {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    };
  }

  const url = API_URL + target;
  return await axios.get(url, head);
}

export async function postData(target, token, data) {
  let head = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const url = API_URL + target;
  return await axios.post(url, data, head);
}

export async function postDataWithParams(target, token, data, params) {
  let head = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
    params: params,
  };
  const url = API_URL + target;
  return await axios.post(url, data, head);
}

export async function postNoRestrict(target, data) {
  const url = API_URL + target;
  return await axios.post(url, data);
}

export async function getNoRestrict(target, params) {
  let head = {
    params: params,
  };
  const url = API_URL + target;
  return await axios.get(url, head);
}

export async function updateData(target, token, id, data) {
  let head = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  let url = API_URL + target;
  if (id.length > 0) {
    url = url + "/" + id;
  }
  return await axios.put(url, data, head);
}

export async function getDataById(target, token, id) {
  let head = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const url = API_URL + target + id;
  return await axios.get(url, head);
}

export async function deleteData(target, token, data) {
  let head = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const url = API_URL + target + data;
  return await axios.delete(url, head);
}

export async function downloadData(target, token, data) {
  let head = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };
  const url = API_URL + target;
  return await axios({
    method: "POST",
    url: url,
    data: data,
    headers: head.headers,
    responseType: "blob",
  });
}

export async function getAllData(dispatch, token) {
  const getData = {
    params: {
      params: {},
    },
    token: token,
  };
  dispatch(getActivity(getData));
  dispatch(getUserManagement(getData));
  dispatch(getRole(getData));
  dispatch(getBank(getData));
  dispatch(getJobPosition(getData));
  dispatch(getPriceType(getData));
  dispatch(getWorkingArea(getData));
  dispatch(getWorkingStatus(getData));
  dispatch(getEmployee(getData));
  dispatch(getFarmer(getData));
  dispatch(getUnitWeight(getData));
  dispatch(getVegetableType(getData));
  dispatch(getVegetable(getData));
  dispatch(getVegetablePrice(getData));
  dispatch(getCustomerGroup(getData));
  dispatch(getCustomerRegion(getData));
  dispatch(getGoodsCategory(getData));
  dispatch(getGoodsOperational(getData));
  dispatch(getDeliveryVehicle(getData));
  dispatch(getCustomer(getData));
  dispatch(getDailyActivity(getData));
  dispatch(
    getReportActivity({
      data: {
        createdAt: {
          $gte: moment().subtract(1, "days").format(),
          $lte: moment()
            .subtract(1, "days")
            .add(23, "hours")
            .add(59, "minutes")
            .format(),
        },
      },
      token: getData.token,
    })
  );
  dispatch(
    getReportNoActivity({
      data: {
        createdAt: {
          $gte: moment().subtract(1, "days").format(),
          $lte: moment()
            .subtract(1, "days")
            .add(23, "hours")
            .add(59, "minutes")
            .format(),
        },
      },
      token: getData.token,
    })
  );

  dispatch(getHarvestEstimate(getData));
  dispatch(getHarvest(getData));
  dispatch(getPurchaseOrder(getData));
  dispatch(getPurchaseOrderCust(getData));
  dispatch(getStockVegetables(getData));
  dispatch(getStockOperationalGoods(getData));
  dispatch(getDeliveryOrder(getData));
  dispatch(getInvoice(getData));
  dispatch(getDebtPlastic(getData));
  dispatch(getOperationalSubmission(getData));
  dispatch(getDebtMoney(getData));

  let getDataHarvestEstimateDashboard = {
    token: token,
    body: {
      status: false,
    },
    params: {
      paginate: false,
    },
  };
  dispatch(getHarvestEstimateDashboard(getDataHarvestEstimateDashboard));
  dispatch(getPurchaseOrderFarmer(getData));
}
